import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import Label from '../label';
import { Styled } from './style';
export default (function (_a) {
    var givenName = _a.givenName, familyName = _a.familyName, email = _a.email, status = _a.status, reverse = _a.reverse;
    var value = '';
    if (reverse && (givenName && familyName)) {
        value = familyName + ", " + givenName;
    }
    else if (givenName || familyName) {
        value = ((givenName || '') + " " + (familyName || '')).trim();
    }
    else if (email) {
        value = email;
    }
    if (status) {
        value = (React.createElement("span", { className: "labelled" },
            value,
            React.createElement(Label, { circular: true, size: "mini", status: status.toLowerCase() },
                React.createElement(FormattedMessage, { id: "ui_component.screen_state." + status.toLowerCase(), defaultMessage: status }))));
    }
    return React.createElement(Styled, null, value);
});
//# sourceMappingURL=index.js.map